export default __webpack_public_path__ + "static/media/About_C.170f7469.png";